import React from 'react';
import { Render, Teaser } from '../platformui/';
export default (props) => (
  <Teaser
    {...props}
    Heading={Render.Property(props.Heading, 'Heading')}
    WrapperModifiers={
      !props.IsListOfChildren ? { 'u-flexwrap--center': true } : null
    }
  />
);
